import React, { useEffect, useState } from 'react'

import Alert from 'components_new/atoms/Alert'

import OnboardingDialog from 'components_new/molecules/OnboardingDialog'

import { welcomeStep } from './utils'
import { useTranslation } from 'language/translator'

interface NewUserDialogProps {
  onClose: () => void
  open: boolean
}

const NewUserDialog = (props: NewUserDialogProps) => {
  const { onClose, open } = props
  const { t } = useTranslation()

  const [step, setStep] = useState(0)

  const N_STEPS = 6

  useEffect(() => {
    if (open) {
      setStep(0)
    }
  }, [open])

  const handleClose = () => {
    onClose()
  }

  return (
    <OnboardingDialog
      contextText={t('guides', welcomeStep[step].body)}
      imageSrc={welcomeStep[step].src}
      onBack={() => setStep(step - 1)}
      onClose={handleClose}
      onNext={step === N_STEPS ? () => onClose() : () => setStep(step + 1)}
      open={open}
      title={t('guides', welcomeStep[step].title)}
      steps={N_STEPS}
      step={step}
    >
      {welcomeStep[step].hint ? (
        <Alert severity="info">
          {step !== 0 ? (
            <>
              <strong>Tips!</strong>
              <br />
            </>
          ) : null}
          {t('guides', welcomeStep[step].hint)}
        </Alert>
      ) : null}
    </OnboardingDialog>
  )
}

export default NewUserDialog
